import { createContext, useContext } from 'react';

const ProjectContext = createContext(null);

/**
 * @param {{ value: { id: string, name: string, status: string, type: string }, children: import('react').ReactNode }} props
 */
export function ProjectContextProvider({ value, children }) {
    return <ProjectContext.Provider value={value}>{children}</ProjectContext.Provider>;
}

/**
 * @returns {{ id: string, name: string, status: string, type: string }}
 */
export function useProjectContext() {
    const ctx = useContext(ProjectContext);
    if (ctx == null) {
        throw new Error('useProjectContext 必须在 WorkspaceLayout（ProjectContextProvider）内使用');
    }
    return ctx;
}
